import { PUBLIC_SWR_KEYS } from "../Utilities/swrKeys";
import { useCachedSWR } from "../Utilities/useCachedSWR";
export const useRegisterFormDataQuery = () => {
    const { data, isLoading } = useCachedSWR(PUBLIC_SWR_KEYS.REGISTER_FORM_DATA);
    return {
        referrals: data === null || data === void 0 ? void 0 : data.referrals,
        shouldShowPrivacyPolicy: data === null || data === void 0 ? void 0 : data.shouldShowPrivacyPolicy,
        privacyPolicyBannerText: data === null || data === void 0 ? void 0 : data.privacyPolicyBannerText,
        privacyPolicyUrl: data === null || data === void 0 ? void 0 : data.privacyPolicyUrl,
        isLoading,
    };
};
